<template>
  <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent="onSubmit">
    <b-form-group label="Caregiving Experience" label-for="caregiving_experience" label-class="form-label">
      <v-select
        id="caregiving_experience"
        class="form-control v-select-custom"
        label="text"
        v-model="research.caregiving_experience"
        :reduce="(exp) => exp.value"
        placeholder="Select required experience"
        :options="workExpOptions"
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
    </b-form-group>

    <b-form-group label="Required Certifications" label-for="required_certs" label-class="form-label">
      <v-select
        id="required_certs"
        class="form-control v-select-custom"
        label="text"
        v-model="research.required_certs"
        :reduce="(exp) => exp.value"
        placeholder="Select required certifications"
        :options="certificationOptions"
        multiple
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
      <b-form-input
        id="other_required_certs"
        class="mt-1"
        placeholder="Please specify"
        v-model="research.other_required_certs"
        required
        v-if="(research.required_certs || []).includes('other')"
        :state="!$v.research.other_required_certs.required && $v.research.other_required_certs.$dirty ? false : null"
      />
    </b-form-group>

    <b-form-group label="Required Records" label-for="required_records" label-class="form-label">
      <v-select
        id="required_records"
        class="form-control v-select-custom"
        label="text"
        v-model="research.required_records"
        :reduce="(exp) => exp.value"
        placeholder="Select required records"
        :options="recordOptions"
        multiple
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
      <b-form-input
        id="other_required_records"
        class="mt-1"
        placeholder="Please specify"
        v-model="research.other_required_records"
        required
        v-if="(research.required_records || []).includes('other')"
        :state="!$v.research.other_required_records.required && $v.research.other_required_records.$dirty ? false : null"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import { pick } from 'lodash';
import { JOB_EXP_OPTIONS, JOB_CERT_OPTIONS, JOB_RECORD_OPTIONS } from '../../../common/constants';

export default {
  name: 'ResearchQualificationsForm',

  props: {
    researchData: { type: Object, required: true },
  },

  data() {
    return {
      research: {
        caregiving_experience: '',
        required_certs: [],
        other_required_certs: null,
        required_records: [],
        other_required_records: null,
      },
      workExpOptions: JOB_EXP_OPTIONS,
      certificationOptions: JOB_CERT_OPTIONS,
      recordOptions: JOB_RECORD_OPTIONS,
    };
  },

  validations() {
    return {
      research: {
        other_required_certs: { required: requiredIf(() => (this.research.required_certs || []).includes('other')) },
        other_required_records: {
          required: requiredIf(() => (this.research.required_records || []).includes('other')),
        },
      },
    };
  },

  watch: {
    researchData: {
      handler() {
        this.research = pick(this.researchData, [
          'caregiving_experience',
          'required_certs',
          'other_required_certs',
          'required_records',
          'other_required_records',
        ]);
      },
      deep: true,
    },
  },

  methods: {
    validateFormData() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
        formData: { ...this.research },
      };
    },
  },
};
</script>
